import AOS from 'aos';

import blockImageSlider from "./blocks/image-slider";
import blockColumnSlider from "./blocks/column-slider";
import {initializeMobileMenu, initializeDesktopMenu} from "./menu";
import { Fancybox } from "@fancyapps/ui";
import blockPromotionsSlider from "./blocks/promotions";


class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        AOS.init({
            disable: 'mobile',
            once: true,
            duration: 1000
        });
        Fancybox.bind('[data-fancybox]', {});
        Fancybox.bind('.wp-block-image > a', {});
        initializeMobileMenu();
        initializeDesktopMenu();
        blockImageSlider();
        blockColumnSlider();
        blockPromotionsSlider();
        // const Woo = new WooCommerce();
    }
}

function initializeApp() {
    const app = new App();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
